export const WITHOUT_SLIPS_TEXTS = 'No momento, não encontrei faturas disponíveis para exibição.'

export const DEFAULT_TITLE_PREFIX = 'Encontrei '

export const DEFAULT_TITLE_SUFIX = ' faturas em aberto para você:'
